import {inject, Injectable} from '@angular/core';
import {TechnicalParametersApiService} from "../services-api/technical-parameters-api.service";

@Injectable({
  providedIn: 'root'
})
export class TechnicalParametersService {
  private technicalParametersApiService: TechnicalParametersApiService = inject(TechnicalParametersApiService);

  public syncPassportArticles(productCardId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.technicalParametersApiService.syncPassportArticles(productCardId).subscribe({
        next:() => resolve(),
        error:(error) => reject(error)
      });
    });
  }
}
